/** Live map grid toolbar: which delay-status buckets are included in search results. */
export enum LiveMapRideFilterEnum {
  all = "all",
  hideNotTracked = "hideNotTracked",
  hideFuturePastNotTracked = "hideFuturePastNotTracked",
}
